// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /strips/assignee-list.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeStripsAssigneeListBody,
  typeStripsAssigneeListOutput200,
} from "../../sdk/strips/postStripsAssigneeList";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildStripsAssigneeListQueryKey(
  payload: typeStripsAssigneeListBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`poolId:${JSON.stringify(payload.poolId)}`);
  queryKeySegments.push(`eventId:${JSON.stringify(payload.eventId)}`);
  queryKeySegments.push(`stripNumber:${JSON.stringify(payload.stripNumber)}`);
  return [
    "post:strips:stripsAssigneeList",
    "svc:contest-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeStripsAssigneeListOutput200,
    unknown,
    typeStripsAssigneeListOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useStripsAssigneeList(
  payload: typeStripsAssigneeListBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildStripsAssigneeListQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postStripsAssigneeList(payload),
    ...resolvedOptions,
  });
}
